import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import settings from "../settings";
import router from "../router";

Vue.use(Vuex);

let new_company_data = {
    is_new: true,
    client_id: null,
    client_url: null,
    contact_address: null,
    contact_email: null,
    contact_phone: null,
    country: "EE",
    created_at: null,
    eu_vat_number: null,
    identification_code: null,
    keep_information_days: null,
    legal_type: null,
    logo_path: null,
    name: null,
    transaction_days: null,
    translations: null
};

let new_user_data = {
    is_new: true,
    first_name: null,
    last_name: null,
    email: null,
    phone_number: null,
    role: null,
    user_status: null,
    locale: null,
    capabilities: null,
    company: null,
    company_role: null,
    user_companies: [
        {
            name: null,
            role: null,
            is_new: true,
            is_deleted: 0
        }
    ]
};


let dashboard_payment_data = {
    start_date: null,
    end_date: null
};

let UIConfigurations = {
    modal: {
        header_and_footer_background_color: '#E8E9F1',
        body_background_color: '#FFFFFF',
        background_color: '#FFFFFF',
        border_color: '#D1D4E3',
        header_text_color: '#4A5995',
        body_text_color: '#36457A',
        footer_text_color: '#747FA4',
        select_text_color: '#2B3D7F',
        hovered_bank_border_color: '#4A5995'
    }
};

import BulkPaymentHistory from "@/store/modules/bulk-payment-history-module";
import PaymentHistory from "@/store/modules/payment-history-module";
import AisModule from "@/store/modules/ais-module";
import OnboardingModule from "@/store/modules/onboarding-module";
import DokobitModule from "@/store/modules/dokobit-module";
/* eslint-disable no-new */
export default new Vuex.Store({
    modules: {
        'bulkPaymentHistory': BulkPaymentHistory,
        'paymentHistory': PaymentHistory,
        'ais': AisModule,
        'onboarding': OnboardingModule,
        'dokobit': DokobitModule,
    },
    state: {
        is_logged_in: (window.app.pageData && window.app.pageData.is_logged_in) || false,
        companies: [],
        bank_names: [],
        users: [],
        translations: {},
        user: {
            id: window.app.pageData.user_id,
            first_name: window.app.pageData.first_name,
            role: window.app.pageData.role,
            email: null,
            password: null,
            error: false,
            company_role: "customer",
            user_companies: [],
            active_company: null
        },
        has_success: true,
        ibansFilled: true,
        payment: [],
        loadingCompanyData: null,
        activeCompany: {},
        activeCompanyBanks: [],
        activeCompanyOrigins: [],
        activeCompanyAllowedIbans: [],
        activeUser: {},
        loadingUserData: null,
        drawerOpen: true,
        apiKey: null,
        requestSuccess: false,
        requestError: false,
        errorMessage: "",
        loadingCompaniesList: false,
        loadingDashboard: false,
        loadingUsersList: false,
        payment_key: null,
        payment_slug: null,
        createPaymentLinkShow: false,
        generatedBanks: [],
        loadingUploadCsv: false,
        paymentImports: [],
        dashboard: {},
        dashboardPaymentHistory: { ...dashboard_payment_data },
        uiConfigurations: {},
    },
    mutations: {
        setDashboard(state, val) {
            state.dashboard = { ...state.dashboard, ...val };
        },
        resetDashboard(state) {
            state.dashboard = {};
        },
        updateDashboardDateSearch(state, payload) {
            state.dashboardPaymentHistory = payload;
            this.dispatch("getDashboardInfo");
        },
        setCompanies(state, val) {
            state.companies = val;
        },

        setBanks(state, val) {
            state.bank_names = [{ name: "All banks", swift: "" }, ...val];
        },
        setUsers(state, val) {
            state.users = val;
        },
        setIsLoggedIn(state, bool) {
            state.is_logged_in = bool;
        },
        updateUserProperty(state, { prop, value }) {
            state.user = {
                ...state.user,
                [prop]: value
            };
        },
        setUserData(state, value) {
            state.user.id = value.id;
            state.user.first_name = value.first_name;
            state.user.role = value.role;
            state.user.company_role = value.company_role;
            state.user.user_companies = value.user_companies;
            state.user.active_company = value.active_company;
        },
        setSuccessStatus(state, bool) {
            state.has_success = bool;
        },
        setPayment(state, value) {
            state.payment = value;
        },
        addTranslations(state, args) {
            state.translations = args.translations;
        },
        setCompanyDataLoading(state, bool) {
            state.loadingCompanyData = bool;
        },
        setUserDataLoading(state, bool) {
            state.loadingUserData = bool;
        },
        setActiveCompany(state, value) {
            state.activeCompany = value;

            if (value && value.ui_configurations) {
                let modalData = {...UIConfigurations.modal}

                if (value.ui_configurations.modal) {
                    modalData = {...modalData, ...value.ui_configurations.modal}
                }
                state.activeCompany.ui_configurations.modal = {...modalData}
            }

        },
        setActiveCompanyMetaPostbackProperty(state, {prop, value}){
            state.activeCompany.meta.postback = {
                ...state.activeCompany.meta.postback,
                [prop]: value
            }
        },
        setActiveCompanyMetaEmbeddedPaymentProperty(state, {prop, value}){
            state.activeCompany.meta.embedded.payment = {
                ...state.activeCompany.meta.embedded.payment,
                [prop]: value
            }
        },
        setActiveCompanyMetaEmbeddedProperty(state, {prop, value, type}){
            state.activeCompany.meta.embedded[type] = {
                ...state.activeCompany.meta.embedded[type],
                [prop]: value
            }
        },
        setActiveCompanyBanks(state, value) {
            state.activeCompanyBanks = value;
        },
        setActiveCompanyOrigins(state, value) {
            state.activeCompanyOrigins = value;
        },
        setActiveCompanyAllowedIbans(state, value) {
            state.activeCompanyAllowedIbans = value;
        },
        setActiveUser(state, value) {
            state.activeUser = value;
        },

        toggleDrawer(state, isOpen) {
            state.drawerOpen = isOpen;
        },
        updateActiveCompanyProperty(state, { prop, value }) {
            state.activeCompany = {
                ...state.activeCompany,
                [prop]: value
            };
        },
        updateActiveCompanyBankProperty(state, { prop, value, index }) {
            state.activeCompanyBanks[index] = {
                ...state.activeCompanyBanks[index],
                [prop]: value
            };
            if ((prop === "recipient_iban" && index === 0) || (prop === "recipient_name" && index === 0)) {
                state.activeCompanyBanks.push({ id: null }); // workaround because without it registration iban dont update
                state.activeCompanyBanks.pop();
            }
        },
        updateActiveCompanyOriginProperty(state, { value, index }) {
            state.activeCompanyOrigins[index] = value;
        },
        updateActiveCompanyAllowedIbanProperty(state, { value, index }) {
            state.activeCompanyAllowedIbans[index] = value;
        },
        updateActiveUserProperty(state, { prop, value }) {
            state.activeUser = {
                ...state.activeUser,
                [prop]: value
            };
        },
        setUiConfigurations(state, val) {
            state.uiConfigurations = val;
        },
        updateActiveUserCompanyProperty(state, { prop, value, index }) {
            Vue.set(state.activeUser.user_companies[index], prop, value);
        },
        addActiveUserCompany(state) {
            state.activeUser.user_companies.push({
                id: Math.floor(Math.random() * 10000),
                is_new: true,
                name: null,
                role: "customer",
                is_deleted: 0
            });
        },
        removeActiveUserCompany(state, index) {
            Vue.set(state.activeUser.user_companies[index], "is_deleted", 1);
        },
        setApiKey(state, value) {
            state.apiKey = value;
        },
        addNewCompany(state) {
            state.activeCompany = new_company_data;
            state.activeCompanyBanks = [];
            state.activeCompanyOrigins = [];
            state.activeCompanyAllowedIbans = [];
        },
        addNewCompanyOrigin(state) {
            state.activeCompanyOrigins.push(null);
        },
        deleteCompanyOrigin(state, { index }) {
            state.activeCompanyOrigins.splice(index, 1);
        },
        addNewCompanyAllowedIban(state) {
            state.activeCompanyAllowedIbans.push(null);
        },
        deleteCompanyAllowedIban(state, { index }) {
            state.activeCompanyAllowedIbans.splice(index, 1);
        },
        addNewUser(state) {
            state.activeUser = new_user_data;
        },
        setRequestSuccess(state, bool) {
            state.requestSuccess = bool;
        },
        setRequestError(state, bool) {
            state.requestError = bool;
        },
        setErrorMessage(state, msg) {
            state.errorMessage = msg;
        },
        setFilledIbanInformation(state, bool) {
            state.ibansFilled = bool;
        },
        updateUserFirstnameProperty(state, value) {
            state.user = {
                ...state.user,
                first_name: value
            };
        },
        setCompaniesListLoading(state, bool) {
            state.loadingCompaniesList = bool;
        },
        setUploadCSVLoading(state, bool) {
            state.loadingUploadCsv = bool;
        },

        setDashboardLoading(state, bool) {
            state.loadingDashboard = bool;
        },
        setUsersListLoading(state, bool) {
            state.loadingUsersList = bool;
        },

        setPaymentKey(state, value) {
            state.payment_key = value;
        },
        setPaymentSlug(state, value) {
            state.payment_slug = value;
        },
        toggleCreatePaymentLinkShow(state, bool) {
            state.createPaymentLinkShow = bool;
        },
        setGeneratedBanks(state, value) {
            state.generatedBanks = value;
        },
        resetCreatePaymentFlow(state) {
            state.payment_key = null;
            state.createPaymentLinkShow = false;
            state.generatedBanks = [];
        },

        setPaymentImports(state, value) {
            state.paymentImports = value;
        },

        resetActiveCompanyUiConfiguration(state) {
            console.log(UIConfigurations)
            state.activeCompany.ui_configurations = {...UIConfigurations};
        }
    },
    actions: {
        async getLoggedUserData({ dispatch, commit }) {
            try {
                const response = await axios.get(settings.app_url + "/login/");
                if (response.status === 200 && response.data.success === 1) {
                    commit("setIsLoggedIn", true);
                    commit("setUserData", response.data);
                    await dispatch("getFilledIbanInformation");
                } else {
                    commit("updateUserProperty", { prop: "error", value: true });
                    dispatch("logOutCurrentUser", true);
                }
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
                commit("updateUserProperty", { prop: "error", value: true });
            }
        },
        async getFilledIbanInformation({ commit }) {
            try {
                const response = await axios.get(settings.app_url + "/iban-check/");
                if (response.status === 200 && response.data.success === 1) {
                    commit("setFilledIbanInformation", response.data.filled);
                } else {
                    commit("setFilledIbanInformation", false);
                }
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
            }
        },
        async fetchTranslations({ commit }, locale) {
            let url = settings.assets_url + "/translations/" + locale + ".json";
            let results = await axios.get(url, { withCredentials: false });
            commit("addTranslations", {
                translations: results.data
            });
        },
        async login({ commit, dispatch }, payload) {
            commit("setRequestSuccess", false);
            commit("setRequestError", false);
            commit("updateUserProperty", { prop: "error", value: false });
            try {
                const response = await axios.post(settings.app_url + "/login/", {
                    email: payload.email.trim(),
                    password: payload.password.trim()
                });
                const data = response.data;
                if (response.status === 200 && data.success === 1) {
                    commit("setIsLoggedIn", true);
                    commit("setUserData", data);
                    if (data.role !== "admin" && data.company_role !== "owner") {
                        await router.push("/admin/landing");
                    } else {
                        await router.push("/admin/dashboard");
                    }
                    await dispatch("getFilledIbanInformation");
                } else {
                    commit("updateUserProperty", { prop: "is_blocked", value: false });

                    if (data.is_blocked) {
                        commit("updateUserProperty", { prop: "is_blocked", value: true });
                    }

                    commit("updateUserProperty", { prop: "error", value: true });
                }
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
                commit("updateUserProperty", { prop: "error", value: true });
            }
        },
        async addProduct({ commit }, payload) {
            commit("setRequestSuccess", false);
            commit("setRequestError", false);
            try {
                const response = await axios.post(settings.app_url + "/payment-create/", payload);
                if (response && response.data && response.data.success === 1) {
                    commit("setPaymentKey", response.data.payment_key);
                    commit("setPaymentSlug", response.data.payment_slug);
                    commit("toggleCreatePaymentLinkShow", true);
                    commit("setGeneratedBanks", response.data.banks);
                } else {
                    this.error = true;
                    commit("setRequestError", true);
                    commit("setErrorMessage", "Failed");
                }
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
            }
        },
        async registerNewUser({ commit }, payload) {
            commit("setRequestSuccess", false);
            commit("setRequestError", false);
            try {
                const response = await axios.post(settings.app_url + "/registration-create/", payload);
                return response.data;
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
            }
        },
        async getCompanies({ commit }) {
            commit("setCompaniesListLoading", true);
            commit("setRequestSuccess", false);
            commit("setRequestError", false);
            try {
                const response = await axios.get(settings.app_url + "/companies/");
                const data = response.data;
                if (data.success === 1) {
                    commit("setCompanies", data.companies);
                } else {
                    commit("setCompanies", []);
                }
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
            }
            commit("setCompaniesListLoading", false);
        },
        async getCompanyData({ commit }, companyId) {
            commit("setCompanyDataLoading", true);
            commit("setRequestSuccess", false);
            commit("setRequestError", false);
            try {
                let response = await axios.get(settings.app_url + "/company/" + companyId);
                if (response && response.data && response.status === 200 && response.data.success === 1) {
                    let data = response.data;
                    if (data.company_data) commit("setActiveCompany", data.company_data);
                    if (data.banks_data) commit("setActiveCompanyBanks", data.banks_data);
                    if (data.origins_data) commit("setActiveCompanyOrigins", data.origins_data);
                    if (data.allowed_iban_data) commit("setActiveCompanyAllowedIbans", data.allowed_iban_data);
                } else {
                    commit("setActiveCompany", {
                        name: null,
                        legal_type: "company",
                        identification_code: null,
                        eu_vat_number: null,
                        country: null,
                        client_url: null,
                        ui_configurations: {}
                    });
                    commit("setActiveCompanyBanks", []);
                    commit("setActiveCompanyOrigins", []);
                    commit("setActiveCompanyAllowedIbans", []);
                    router.push("/admin/companies");
                }
            } catch (e) {
                console.log(e);
                commit("setRequestError", true);
                commit("setErrorMessage", "Failed");
            }
            commit("setCompanyDataLoading", false);
        },
        async getUsers({ commit }) {
            commit("setUsersListLoading", true);
            commit("setRequestSuccess", false);
            commit("setRequestError", false);
            try {
                const response = await axios.get(settings.app_url + "/users/");
                const data = response.data;
                if (data.success === 1) {
                    commit("setUsers", data.users);
                } else {
                    commit("setUsers", []);
                }
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
            }
            commit("setUsersListLoading", false);
        },
        async getUserData({ commit }, userId) {
            commit("setUserDataLoading", true);
            try {
                let response = await axios.get(settings.app_url + "/user/" + userId);
                if (response && response.data && response.status === 200 && response.data.success === 1) {
                    let data = response.data;
                    commit("setActiveUser", data.user_data);
                } else {
                    commit("setActiveUser", {});
                    router.push("/admin/users");
                }
            } catch (e) {
                console.log(e);
            }
            commit("setUserDataLoading", false);
        },
        async generateNewClientId({ commit }, companyId) {
            commit("setCompanyDataLoading", true);
            try {
                let response = await axios.post(settings.app_url + "/company/?id=" + companyId + "&act=client-id", {});
                if (response && response.data && response.status === 200) {
                    let data = response.data;
                    commit("setActiveCompany", data.company_data);
                }
            } catch (e) {
                console.log(e);
            }
            commit("setCompanyDataLoading", false);
        },
        async generateNewApiKey({ commit }, companyId) {
            commit("setCompanyDataLoading", true);
            try {
                let response = await axios.post(settings.app_url + "/company/?id=" + companyId + "&act=api-key", {});
                if (response && response.data && response.status === 200) {
                    let data = response.data;
                    commit("setApiKey", data.api_key);
                }
            } catch (e) {
                console.log(e);
            }
            commit("setCompanyDataLoading", false);
        },
        async submitCompanyUpdate({ commit, dispatch }, { company, banks, origins, allowed_ibans }) {
            commit("setCompanyDataLoading", true);
            commit("setRequestSuccess", false);
            commit("setRequestError", false);
            try {
                let response = await axios.post(settings.app_url + "/company/", {
                    data: company,
                    banks: banks,
                    origins: origins ? origins : [],
                    allowed_ibans: allowed_ibans ? allowed_ibans : []
                });

                if (response.status === 200 && response.data.success === 1) {
                    if (response.data.success === 1) {
                        await dispatch("getFilledIbanInformation");
                        return { status: 1, id: response.data.company_id };
                    } else {
                        commit("setRequestError", true);
                        commit("setErrorMessage", response.data.error_msg);
                        return { status: 0 };
                    }
                }
            } catch (e) {
                console.log(e);
            }
            commit("setCompanyDataLoading", false);
        },
        async submitUserUpdate({ commit }, user) {
            commit("setUserDataLoading", true);
            commit("setRequestSuccess", false);
            commit("setRequestError", false);

            try {
                let response = await axios.post(settings.app_url + "/user/", user);
                if (response.status === 200) {
                    if (response.data.success === 1) {
                        return {
                            status: 1,
                            id: response.data.user_id,
                            pw_changed: !!response.data.password_changed
                        };
                    } else {
                        !response.data.error_msg ? commit("setErrorMessage", "Failed") : commit("setErrorMessage", response.data.error_msg);
                        return { status: 0 };
                    }
                }
            } catch (e) {
                console.log(e);
                commit("setRequestError", true);
                commit("setErrorMessage", "Failed");
            }
            commit("setUserDataLoading", false);
        },
        async checkActivationValidity({ commit }, payload) {
            try {
                let data = {
                    email: payload.email.trim(),
                    hash: payload.hash.trim(),
                    pw: payload.pw,
                    type: payload.type
                };
                const response = await axios.post(settings.app_url + "/activation", data);
                return response.data;
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
                commit("updateUserProperty", { prop: "error", value: true });
            }
        },
        async getAvailableBanks({ commit }) {
            try {
                let result = await axios.get(settings.app_url + "/banks/");
                if (result && result.data.success === 1) {
                    commit("setActiveCompanyBanks", result.data.banks);
                }
                return result;
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
            }
        },
        async submitAvailableBanks({ commit }, payload) {
            commit("setRequestSuccess", false);
            commit("setRequestError", false);
            try {
                let result = await axios.put(settings.app_url + "/banks/", payload);
                if (result && result.data.success === 0) {
                    commit("setRequestError", true);
                    commit("setErrorMessage", result.data.error_msg);
                }
                return result;
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
                commit("setRequestError", true);
                commit("setErrorMessage", "Failed");
            }
        },
        async logOutCurrentUser({ commit, state }, directToLogin) {
            try {
                commit("setUserData", {
                    id: null,
                    first_name: null,
                    role: null,
                    company_role: null
                });
                commit("setFilledIbanInformation", true);
                if (state.is_logged_in) {
                    await axios.delete(settings.app_url + "/return-user-data/");
                }
                commit("setIsLoggedIn", false);
                window.localStorage.clear();
                if (directToLogin) await router.push("/app/login");
            } catch (e) {
                console.log(e);
            }
        },
        async resendActivationLink({ commit }, payload) {
            commit("setRequestSuccess", false);
            commit("setRequestError", false);
            let data = {
                id: payload.id,
                email: payload.email,
                type: "resend-activation"
            };
            try {
                const response = await axios.post(settings.app_url + "/activation", data);
                return response.data;
            } catch (e) {
                console.log(e);
            }
        },
        async deleteCompany({ commit }, { company_id }) {
            commit("setRequestSuccess", false);
            commit("setRequestError", false);
            try {
                const response = await axios.delete(settings.app_url + "/company/", {
                    params: { company_id }
                });

                if (response.status === 200 && response.data.success === 1) {
                    return { status: 1 };
                } else {
                    return { status: 0 };
                }
            } catch (e) {
                console.log(e);
            }
        },
        async deleteUser({ commit }, { user_id }) {
            commit("setRequestSuccess", false);
            commit("setRequestError", false);
            try {
                const response = await axios.delete(settings.app_url + "/user/", {
                    params: { user_id }
                });

                if (response.status === 200 && response.data.success === 1) {
                    return { status: 1 };
                } else {
                    commit("setRequestError", true);
                    commit("setErrorMessage", "Failed");
                    return { status: 0 };
                }
            } catch (e) {
                console.log(e);
            }
        },
        async importCsvFile({ commit, dispatch }, e) {
            commit("setRequestSuccess", false);
            commit("setRequestError", false);
            commit("setUploadCSVLoading", true);
            let formData = new FormData();
            formData.append("file", e);
            try {
                let response = await axios.post(settings.app_url + "/upload-csv/", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                });
                if (response.status === 200) {
                    if (response.data.success === 1) {
                        commit("setRequestSuccess", true);
                        await dispatch("getPaymentImports");
                    } else {
                        commit("setRequestError", true);
                        commit("setErrorMessage", response.data.error_msg);
                    }
                }
            } catch (e) {
                console.log(e);
            }
            commit("setUploadCSVLoading", false);
        },
        async getPaymentImports({ commit }) {
            commit("setRequestSuccess", false);
            commit("setRequestError", false);
            commit("setUploadCSVLoading", true);
            try {
                const response = await axios.get(settings.app_url + "/payment-imports/");
                const data = response.data;
                if (data.success === 1) {
                    commit("setPaymentImports", data.payment_imports);
                } else {
                    commit("setPaymentImports", []);
                }
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
            }
            commit("setUploadCSVLoading", false);
        },
        async changeCompany({ commit }, user_company_id) {
            commit("setRequestSuccess", false);
            commit("setRequestError", false);
            try {
                let data = { ...user_company_id };
                let response = await axios.post(settings.app_url + "/change-company/", data);
                if (response?.data?.success === 1) {
                    window.location.reload();
                } else {
                    commit("setRequestError", true);
                    commit("setErrorMessage", "Something went wrong");
                }
            } catch (e) {
                console.log(e);
                commit("setRequestError", true);
                commit("setErrorMessage", "Something went wrong");
            }
        },
        async getDashboardInfo({ commit, state }) {
            commit("setDashboardLoading", true);
            commit("setRequestSuccess", false);
            commit("setRequestError", false);
            let search = state.dashboardPaymentHistory;
            let params = {
                start_date: search && search.start_date ? search.start_date : null,
                end_date: search && search.end_date ? search.end_date : null,
                company_id: search && search.company_id ? search.company_id : "all"
            };
            try {
                const response = await axios.get(settings.app_url + "/dashboard/", { params });
                const data = response.data;
                if (data.success === 1) {
                    commit("setDashboard", {
                        ...data.statuses,
                        ...params
                    });
                } else {
                    commit("resetDashboard")
                }
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
            }
            commit("setDashboardLoading", false);
        },
        async fetchUiConfigurations({commit}, {paymentKey, isBulkPayment}) {
            commit("setRequestSuccess", false);
            commit("setRequestError", false);
            try {
                const params = {
                    'payment_key': paymentKey,
                    'is_bulk_payment': isBulkPayment
                }
                const response = await axios.get(`${settings.app_url}/ui-configurations/`,{ params });

                if (response.data.success) {
                    return response.data.ui_configurations;
                }
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
            }

            return null;
        }
    }
});
